import moment from 'moment';
import { isOneWeekOrLess } from './dateTimeUtils';

// تبدیل تاریخ به آبجکت مومنت
export const convertDate = (_data) => {
  return moment.unix(_data);
};

// تعداد روزهای انتخاب شده از تاریخ
export const dateTimeToHour = (timeDuration, fromDate, toDate) => {
  if (timeDuration === 'today') {
    const a = convertDate(moment().format('YYYY-MM-DD 00:00'));
    const b = convertDate(moment().format('YYYY-MM-DD HH:mm'));
    return b.diff(a, 'hour');
  }

  if (timeDuration === '6h') return 6;

  if (timeDuration === '24h') return 24;

  if (timeDuration === '1w') return 24 * 7;

  if (timeDuration === '2w') return 24 * 14;

  if (timeDuration === '1m') return 24 * 30;

  if (timeDuration === '3m') return 24 * 30 * 3;

  if (timeDuration === '6m') return 24 * 30 * 6;

  if (timeDuration === '12m') return 24 * 30 * 12;

  const a = convertDate(fromDate);
  const b = convertDate(toDate);
  const diff = b.diff(a, 'hour');
  return diff;
};

/**
 * در صفحات شناسنامه پروفایل و آمار و نمودارها، برای تشخیص دکمه هفتگی، روزانه، ساعتی روی نمودارهای روند رشد و گیج سرعت انتشار مطلب استفاده میشود
 * @param {*} timeDuration
 * @param {*} fromDate
 * @param {*} toDate
 * @param {*} time_gap
 * @returns
 */
export const getFullObjectOfDays = (
  timeDuration,
  fromDate,
  toDate,
  time_gap,
  type
) => {
  const _numberOfHour = dateTimeToHour(timeDuration, fromDate, toDate);
  let _numberOfDays = _numberOfHour;

  // بدست آوردن نوع محاسبه دیتای گیج سرعت انتشار - که بر حسب ساعت باشه یا روز
  const _timeGapOfGauge = time_gap || 'hour';

  // اگر سرعت انتشار مطلب به صورت روزانه بود عدد بر 24 تقسیم می‌شود
  if (type === 'gauge' && _timeGapOfGauge === 'day') {
    _numberOfDays = _numberOfHour / 24;
  }

  // اگر تعداد روز کمتر از 1 شد
  if (_numberOfDays < 1) {
    _numberOfDays = 1;
  }

  // اگر کمتر از 24 ساعت بود، نمایش به صورت روزانه و هفتگی فعال شود
  const _disabledDaily = _numberOfHour <= 24;
  const _disabledWeekly = !!(
    _timeGapOfGauge === 'hour' && _numberOfDays / 24 < 7
  );

  return {
    numberOfDays: _numberOfDays,
    timeGapOfGauge: _timeGapOfGauge,
    disabledDaily: _disabledDaily,
    disabledWeekly: _disabledWeekly,
  };
};

export const getDisabledTimeGaps = (currentDate, feature) => {
  if (feature === 'brandBaan' && isOneWeekOrLess(currentDate)) {
    return ['hour'];
  }
};
